
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 11 11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.97 5.035H7.109v-1.86c0-.195-.042-.387-.123-.564-.082-.181-.2-.343-.347-.476a1.719 1.719 0 00-2.274 0 1.414 1.414 0 00-.472 1.04v1.86H2.032v-1.86c0-.42.09-.833.264-1.214.177-.392.433-.744.751-1.032.328-.3.71-.533 1.127-.688a3.78 3.78 0 012.654 0c.416.155.799.388 1.127.688.318.288.573.639.751 1.03.174.381.264.796.264 1.216v1.86z","fill":"#00FFA1"}}),_c('path',{attrs:{"d":"M9.055 11h-7.11a2.072 2.072 0 01-.745-.135 1.935 1.935 0 01-.63-.39 1.767 1.767 0 01-.423-.577A1.638 1.638 0 010 9.218V5.966c0-.236.05-.47.149-.683.099-.219.241-.415.418-.576a2.055 2.055 0 011.376-.522h7.112c.255-.001.507.044.745.135.232.087.445.217.629.384.18.161.323.358.423.578.098.214.149.448.148.684v3.254c0 .235-.05.468-.149.683-.1.218-.243.414-.421.575-.183.168-.397.299-.63.387a2.1 2.1 0 01-.745.135zM1.867 5.936l-.006 3.283 7.273.027.006-3.282-7.273-.028z","fill":"#00FFA1"}})])
          )
        }
      }
    